export default __webpack_public_path__ + "static/media/loading_bar.0cc90751.gif";